import { GOOGLE_ONE_TAP_REDIRECTING_EVENT } from "@circle-react/constants/googleOneTapEvents";
import { useEffect } from "react";

const GIS_INTERMEDIATE_SRC = "https://accounts.google.com/gsi/intermediate";
const GIS_INTERMEDIATE_SCRIPT_ID = "google-one-tap-intermediate";

interface GoogleOneTapIntermediateProps {
  iframeSrc: string;
}

export const GoogleOneTapIntermediate = ({
  iframeSrc,
}: GoogleOneTapIntermediateProps) => {
  useEffect(() => {
    if (document.getElementById(GIS_INTERMEDIATE_SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");
    script.id = GIS_INTERMEDIATE_SCRIPT_ID;
    script.src = GIS_INTERMEDIATE_SRC;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent<{ type?: string }>) => {
      if (event.data?.type !== "google-one-tap-redirecting") return;
      window.dispatchEvent(new CustomEvent(GOOGLE_ONE_TAP_REDIRECTING_EVENT));
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return <div id="g_id_intermediate_iframe" data-src={iframeSrc} />;
};
